<template>
    <div>
        <div @click="closeAction(isFirst)" v-if="isOpen || isFirst" :style="{ zIndex: zIndex, backgroundColor: isModalBackTransparent ? '' : 'rgba(0, 0, 0, 0.2);' }" style="position: fixed; top: 0; left: 0; width: 100%; height: 100%; background-color: rgba(0, 0, 0, 0.2); z-index: 10; will-change: transform;"></div>
        <section ref="editPage" @touchstart="touchStart($event)" @touchmove="touchMove($event)" @touchend="touchEnd($event)" class="edit-page" :class="{ open: isOpen }" :style="{ bottom: calcBottom + 'px', height: changeHeight + changeHeightUnit, paddingBottom: changeBottom + 'px', zIndex: zIndex, backgroundColor: backgroundColor, transform: isOpen ? 'translateY(50px)' : `translateY(100%)` }">
            <slot></slot>
        </section>
    </div>
</template>

<script>
export default {
    name: "TeamTrainingPopupFrame",
    props: {
        isOpen: {
            type: Boolean,
            default: false,
        },
        isModalBackTransparent: {
            type: Boolean,
            default: false,
        },
        closeCompleteAction: {
            type: Function,
            default: () => { }
        },
        changeHeight: {
            type: [Number, String],
            default: 90,
        },
        changeHeightUnit: {
            type: String,
            default: '%'
        },
        changeBottom: {
            type: Number,
            default: 90,
        },
        zIndex: {
            type: Number,
            default: 10
        },
        backgroundColor: {
            type: String,
            default: '#fff'
        },
        isBackPressApply: {
            type: Boolean,
            default: false,
        },
        translateY: {
            type: String,
            default: '100%'
        },
        openModal: {
            type: Function,
            default: () => { }
        },
        changeOverflow: {
            type: Function,
            default: () => { },
        },
        modalScrollTop: {
            type: Number,
            default: 0
        },
        isListModal: {
            type: Boolean,
            default: true
        }
    },
    watch: {
        // isOpen() {
        //     if (!this.isBackPressApply) return;
        //     if (this.isOpen) {
        //         this.$GlobalStore.addPopFlag(this.closeCompleteAction);
        //     } else {
        //         this.closeCompleteAction();
        //     }
        // }
        isOpen() {
            this.editPage.transition = 'transform .5s, height .5s'
        }
    },
    computed: {
        fullSizeHeight() {
            return this.$GlobalStore.statusBarHeight() + this.$GlobalStore.navigationBarHeight()
        }
    },
    data() {
        return {
            scrollY: 0,
            startY: 0,
            movePanelBottom: 0,
            lastOpen: false,
            isEndPhase: false,
            calcHeight: 0,
            calcBottom: 0,
            adjustHeight: 0,
            editPage: null,
            isFirst: true,
            standardScrollY: 0
        }
    },
    mounted() {
        const baseHeight = 844 + this.fullSizeHeight;
        const elementHeight = 627;
        const screenHeight = window.innerHeight
        const calculatedHeight = (elementHeight / baseHeight) * screenHeight;

        this.adjustHeight = calculatedHeight
        this.editPage = this.$refs.editPage.style
        if (this.isListModal) {
            this.$nextTick(() => {
                this.$refs.editPage.style.transition = 'transform .5s, height .5s'
                this.$refs.editPage.style.transform = `translateY(${calculatedHeight - 270}px)`
            })
        }
    },
    methods: {
        closeAction(isFirst) {
            this.closeCompleteAction()
            if (isFirst) {
                this.isFirst = false
                this.editPage.transform = `translateY(100%)`
            }
        },
        calcScrollY(difference) {
            if (!this.isOpen && this.isFirst) {
                return this.startScrollY + difference + this.adjustHeight - 270
            } else if (this.isOpen && !this.isFirst) {
                return this.startScrollY + difference + 50
            } else if (!this.isOpen && !this.isFirst) {
                return this.startScrollY + difference + this.adjustHeight
            }
        },
        touchStart(e) {
            const touch = e.touches[0] || e.changedTouches[0];
            this.startY = touch.pageY;
            this.startScrollY = this.scrollY;
            this.editPage.transition = ''
            const standardScrollY = this.calcScrollY(this.startScrollY)
            this.standardScrollY = standardScrollY
        },
        touchMove(e) {
            if (this.modalScrollTop !== 0) {
                return
            }
            const touch = e.touches[0] || e.changedTouches[0];
            const difference = touch.pageY - this.startY;
            this.scrollY = this.calcScrollY(difference);

            if (this.scrollY <= 50) {
                return
            }
            this.editPage.transform = `translateY(${this.scrollY}px)`
        },
        touchEnd() {
            this.isFirst = false
            if (this.scrollY > this.standardScrollY) {
                this.editPage.transition = 'transform .5s, height .5s'
                this.changeOverflow(true)
                this.closeCompleteAction()
                this.editPage.transform = `translateY(100%)`
                this.scrollY = 0
            } else {
                this.editPage.transition = 'transform .5s, height .5s'
                this.openModal()
                this.changeOverflow(false)
                this.scrollY = 0
            }
            setTimeout(() => {
                this.editPage.transition = ''
            }, 500)
        },
    },
}
</script>

<style scoped>
.edit-page {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    display: flex;
    flex-direction: column;
    background: #fff;
    transform: translateY(100%);
    will-change: transform;
    /* transition: transform 0.5s, height 0.5s; */
    animation-timing-function: ease-out;
    border-top-left-radius: 25px;
    border-top-right-radius: 25px;
    /* padding-bottom: 90px; */
    box-sizing: border-box;
}

.edit-page.open {
    transform: translateY(0);
}
</style>